import { render, staticRenderFns } from "./AddingServices.vue?vue&type=template&id=2cafbccc&scoped=true&"
import script from "./AddingServices.vue?vue&type=script&lang=ts&"
export * from "./AddingServices.vue?vue&type=script&lang=ts&"
import style0 from "./AddingServices.vue?vue&type=style&index=0&id=2cafbccc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cafbccc",
  null
  
)

export default component.exports